/** Shared support ticket labels — keep in sync with backend ALLOWED_CATEGORIES. */
export const SUPPORT_CATEGORIES = {
  cancel_refund: 'Cancel / Refund',
  date_change: 'Date Change',
  name_correction: 'Name Correction',
  seat_selection: 'Seat Selection',
  add_baggage: 'Add Baggage',
  add_meal: 'Add Meal',
  special_request: 'Special Request',
  gst_invoice: 'GST / Invoice',
  payment_wallet: 'Payment / Wallet',
  schedule_change: 'Schedule Change',
  failed_booking: 'Failed Booking',
  reprice: 'Reprice',
  supplier_escalation: 'Supplier Escalation',
  group_booking: 'Group Booking',
  seat_block: 'Seat Block',
  general_inquiry: 'General Inquiry',
  other: 'Other',
};

export const B2C_STATUS_TABS = [
  { id: 'all', label: 'All', tone: 'bg-gray-100 text-gray-700' },
  { id: 'unread', label: 'Unread', tone: 'bg-red-100 text-red-700' },
  { id: 'open', label: 'Open', tone: 'bg-blue-100 text-blue-700' },
  { id: 'in_process', label: 'In Process', tone: 'bg-amber-100 text-amber-700' },
  { id: 'need_reply', label: 'Need Reply', tone: 'bg-purple-100 text-purple-700' },
  { id: 'closed', label: 'Closed', tone: 'bg-slate-100 text-slate-600' },
];

export const AGENT_STATUS_TABS = [
  { id: 'all', label: 'All', tone: 'bg-gray-100 text-gray-700' },
  { id: 'need_reply', label: 'Reply needed', tone: 'bg-amber-100 text-amber-800' },
  { id: 'in_process', label: 'ACF handling', tone: 'bg-teal-100 text-teal-800' },
  { id: 'unread', label: 'Submitted', tone: 'bg-sky-100 text-sky-800' },
  { id: 'open', label: 'Open', tone: 'bg-blue-100 text-blue-700' },
  { id: 'closed', label: 'Resolved', tone: 'bg-slate-100 text-slate-600' },
];

export const PRIORITY_COLORS = {
  normal: 'text-gray-600',
  urgent: 'text-orange-600 font-semibold',
  critical: 'text-red-600 font-bold',
};

/** Human-readable status for travel agents. */
export const AGENT_STATUS_LABELS = {
  unread: 'With ACF support',
  open: 'With ACF support',
  in_process: 'ACF is handling',
  need_reply: 'Reply needed',
  closed: 'Resolved',
};

export const AGENT_STATUS_TONES = {
  unread: 'bg-sky-100 text-sky-800',
  open: 'bg-sky-100 text-sky-800',
  in_process: 'bg-teal-100 text-teal-800',
  need_reply: 'bg-amber-100 text-amber-900 font-semibold',
  closed: 'bg-slate-100 text-slate-600',
};

export const B2C_STATUS_TONES = {
  unread: 'bg-red-100 text-red-700',
  open: 'bg-blue-100 text-blue-700',
  in_process: 'bg-amber-100 text-amber-700',
  need_reply: 'bg-purple-100 text-purple-700',
  closed: 'bg-slate-100 text-slate-600',
};

export const SUPPORT_API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AGENT_LIST_POLL_MS = 45000;

export function getCategoryLabel(category) {
  return SUPPORT_CATEGORIES[category] || category || '—';
}
